export default {
  allMsg: 'Tous les messages',
  systemMsg: 'Messages système',
  personMsg: 'Messages manuels',
  unread: 'Non lu',
  seeDetail: 'Voir les détails',
  read: 'Lu',
  replyNow: 'Répondre maintenant',
  message: 'Message',
  operateSuccess: 'Opération réussie',
  holder: {
    searchHolder: "N° de colis/N° de commande/N° d'article",
  },
  addAcBuy: 'Rejoignez AcBuy Discord et gagnez 2000 ¥ en CASH !',
  joinNow: 'Rejoindre ici',
  flatActivity: "Partagez votre expérience d'achat sur Taobao & AcBuy — Gagnez 1500 ¥ en CASH !",
  joinNow1: 'Rejoindre maintenant',
  tips1: 'Concours officiel Labubu par Acbuy',
  tips2: 'Énorme distribution de Labubu & set complet ZIMOMO à gagner ',
}
